import { API } from '../../apis/limeAuthUtils/apiWrapper';
import { getCurrentAuthUserEmail } from '../../lib/utils';

/**
 * function to fetch device config for all devices owned by the person
 * @param region
 * @returns {Promise<*>}
 */
export async function fetchDeviceConfig(region) {
    const authUserEmail = await getCurrentAuthUserEmail();
    const apiName = `${region}/v1/device-configs`;
    const myInit = {
        queryStringParameters: {
            requester: authUserEmail,
        },
    };
    return await API.get(apiName, '/v1/device-configs', myInit);
}

/**
 * function to delete device config
 * @param dsn
 * @param labId
 * @param region
 * @returns {Promise<*>}
 */
export async function deleteDeviceConfig(dsn, labId, region) {
    const authUserEmail = await getCurrentAuthUserEmail();
    const apiName = `${region}/v1/device-configs`;
    const myInit = {
        body: {
            dsn: dsn,
            requester: authUserEmail,
            labId: labId,
        },
    };
    return await API.del(apiName, '/v1/device-configs', myInit);
}
